// config
import { HEADER, ThemeConfig } from "../../../../config";
// @mui
import { styled, alpha } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
// components
import AccountPopover from "components/layouts/dashboard/Header/AccountPopover";
import { ThemeSettings } from "components/common/ThemeSettings";
// hooks
import { useCollapseDrawer } from "hooks/index";
// types
import type { ThemeOrientation } from "theme/index";
import { Notifications } from "components/layouts/dashboard/Header/Notifications";

interface StyledHeaderProps {
  isCollapse: boolean;
  isOffset?: boolean;
  themeOrientation: ThemeOrientation;
}

const RootStyle = styled(Toolbar, {
  shouldForwardProp: (prop) =>
    prop !== "isCollapse" && prop !== "isOffset" && prop !== "themeOrientation",
})<StyledHeaderProps>(({ isCollapse, isOffset, themeOrientation, theme }) => ({
  boxShadow: "none",
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  overflow: "hidden",
  backdropFilter: "blur(24px)",
  WebkitBackdropFilter: "blur(24px)",
  backgroundColor: alpha(theme.palette.background.paper, 0.72),
  borderBottom:
    theme.palette.mode === "dark"
      ? `1px solid rgba(255, 255, 255, 0.04)`
      : "none",
  transition: theme.transitions.create(
    ["width", "height", "background-color"],
    {
      duration: theme.transitions.duration.shorter,
    }
  ),
  padding: `0 ${theme.spacing(3)} !important`,

  [theme.breakpoints.up("lg")]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    ...(isCollapse && {}),
    ...(isOffset && {
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
    }),
    ...(themeOrientation === "vertical" && {
      width: "100%",
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
      backgroundColor: alpha(theme.palette.background.default, 0.72),
    }),
  },
}));

export const DashboardHeader = () => {
  const { themeOrientation } = ThemeConfig;
  const { isCollapse } = useCollapseDrawer();

  return (
    <RootStyle isCollapse={isCollapse} themeOrientation={themeOrientation}>
      <AccountPopover />

      <Box sx={{ flexGrow: 1 }} />

      <Stack direction="row" alignItems="center" spacing={0.5}>
        <ThemeSettings />
        <Notifications />
      </Stack>
    </RootStyle>
  );
};
